/**
 * Écart compteur (fin − début) pour un relevé d'heures ou de KM sur un BT.
 * Retourne null si l'une des deux bornes est absente.
 */
export function ecartReleve(debut?: number | null, fin?: number | null): number | null {
    if (debut == null || fin == null) {
        return null;
    }
    return fin - debut;
}

export type UniteEcartReleve = 'h' | 'km';

export interface LigneEcartReleve {
    unite: UniteEcartReleve;
    valeur: number;
    texte: string;
    aCru: boolean;
    aBaisse: boolean;
}

/**
 * Formate un écart avec son unité, ex. `+12h`, `0km`, `-5h`.
 */
export function formaterEcartReleve(valeur: number, unite: UniteEcartReleve): string {
    const signe = valeur > 0 ? '+' : '';
    return `${signe}${valeur}${unite}`;
}

/**
 * Construit les lignes d'écart heures puis KM. Une ligne est omise si les données
 * de ce type sont insuffisantes.
 */
export function lignesEcartReleve(params: {
    heuresDebut?: number | null;
    heuresFin?: number | null;
    kmDebut?: number | null;
    kmFin?: number | null;
}): LigneEcartReleve[] {
    const lignes: LigneEcartReleve[] = [];

    const heures = ecartReleve(params.heuresDebut, params.heuresFin);
    if (heures != null) {
        lignes.push({
            unite: 'h',
            valeur: heures,
            texte: formaterEcartReleve(heures, 'h'),
            aCru: heures > 0,
            aBaisse: heures < 0
        });
    }

    const km = ecartReleve(params.kmDebut, params.kmFin);
    if (km != null) {
        lignes.push({
            unite: 'km',
            valeur: km,
            texte: formaterEcartReleve(km, 'km'),
            aCru: km > 0,
            aBaisse: km < 0
        });
    }

    return lignes;
}
